import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core'
import { IQuestionComponent } from 'app/interfaces/IQuestionComponent'
import { Kano } from 'app/models/questions/Kano'
import { AbstractControl } from '@angular/forms'
import { OpenStatementErrorMatcher } from 'app/error-matchers/OpenStatementErrorMatcher'
import { SurveyViewerService } from 'app/modules/survey/survey-viewer/services/survey-viewer.service'
import {InputPersistenceService} from '../../../services/input-persistence.service';
import {Subject, takeUntil} from "rxjs";

@Component({
  selector: 'app-kano',
  templateUrl: './kano.component.html',
  styleUrls: ['./kano.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KanoComponent implements IQuestionComponent, OnInit, OnDestroy {

  @Input() activeLang: string
  @Input() isSmallScreen: boolean
  @Input() question: Kano

  questionFormControl: AbstractControl
  errorMatcher: OpenStatementErrorMatcher
  private ngUnsubscribe = new Subject<void>();

  constructor(
    public surveyViewerService: SurveyViewerService,
    private inputPersistence: InputPersistenceService
  ) { }

  ngOnInit(): void {
    this.errorMatcher = new OpenStatementErrorMatcher(this.question.isOptional)
    this.questionFormControl = this.surveyViewerService.activeSurvey$.value.form.get(this.question.key)
    
    // Restaurer les valeurs sauvegardées si elles existent (priorité à la valeur en cours de saisie)
    this.question.rowKeys.forEach(rKey => {
      this.question.statementKeys.forEach(sKey => {
        const commentsControl = this.questionFormControl.get(rKey)?.get(this.question.commentsControlName)?.get(sKey);
        if (commentsControl) {
          const savedValue = this.inputPersistence.getValue(this.question.key, sKey, rKey);
          if (savedValue) {
            commentsControl.setValue(savedValue, {emitEvent: false});
          }
        }
      });
    });

    // Surveiller les changements du Survey pour restaurer les valeurs quand le formulaire se recharge
    this.surveyViewerService.activeSurvey$.pipe(
      takeUntil(this.ngUnsubscribe)
    ).subscribe(survey => {
      if (survey) {
        this.question.rowKeys.forEach(rKey => {
          this.question.statementKeys.forEach(sKey => {
            const newCommentsControl = survey.form
              .get(this.question.key)
              ?.get(rKey)
              ?.get(this.question.commentsControlName)
              ?.get(sKey);
            
            if (newCommentsControl) {
              const currentValue = newCommentsControl.value;
              const savedValue = this.inputPersistence.getValue(this.question.key, sKey, rKey);
              
              if (savedValue && (!currentValue || currentValue === '')) {
                setTimeout(() => {
                  newCommentsControl.setValue(savedValue, {emitEvent: false});
                }, 0);
              }
            }
          });
        });
      }
    });
  }

  /**
   * Sauvegarde la valeur en temps réel (appelé à chaque frappe)
   */
  onInput(value: string, sKey: string, rKey: string){
    this.inputPersistence.saveValue(this.question.key, value, sKey, rKey);
  }

  /**
   * Appelé au blur (pas de nettoyage ici pour éviter la perte lors du rechargement)
   */
  onBlur(sKey: string, rKey: string){
    // Note: On ne nettoie PAS ici car le formulaire peut se recharger juste après
  }

  ngOnDestroy(){
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
